import { useQuery } from '@tanstack/react-query';
import api from '../services/authService';

const DEFAULT_PER_PAGE = 15;

export const useAdminPlatformAudit = ({
  page = 1,
  perPage = DEFAULT_PER_PAGE,
  eventType = '',
  dateFrom = '',
} = {}) => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['adminPlatformAudit', page, perPage, eventType, dateFrom],
    queryFn: async () => {
      const params = { page, per_page: perPage };
      if (eventType) params.event_type = eventType;
      if (dateFrom) params.date_from = dateFrom;

      const response = await api.get('/admin/platform-audit', { params });
      return response.data;
    },
    staleTime: 30 * 1000,
  });

  return {
    events: data?.data?.events || [],
    pagination: data?.data?.pagination || {
      current_page: 1,
      last_page: 1,
      total: 0,
      per_page: perPage,
    },
    isLoading,
    error,
    refetch,
  };
};
